// import React, { useState } from "react";

// const contentData = {
//   kryzen: {
//     title: "Kryzen Biotech",
//     colors: {
//       primary: "#0d6efd",
//       secondary: "#6c757d",
//       accent: "#20c997",
//     },
//     font: {
//       headline: "Poppins",
//       subheading: "Roboto",
//     },
//   },
//   hydroponic: {
//     title: "Hydroponic Masterclass",
//     colors: {
//       primary: "#198754",
//       secondary: "#ffc107",
//       accent: "#0dcaf0",
//     },
//     font: {
//       headline: "Montserrat",
//       subheading: "Open Sans",
//     },
//   },
//   sudhir: {
//     title: "Sudhir Devkar",
//     colors: {
//       primary: "#6610f2",
//       secondary: "#adb5bd",
//       accent: "#fd7e14",
//     },
//     font: {
//       headline: "Playfair Display",
//       subheading: "Lato",
//     },
//   },
//   eatpure: {
//     title: "Eat Pure Greens",
//     colors: {
//       primary: "#198754",
//       secondary: "#dc3545",
//       accent: "#ffc107",
//     },
//     font: {
//       headline: "Raleway",
//       subheading: "Nunito",
//     },
//   },
// };

// const CreativeStandard = () => {
//   const [selected, setSelected] = useState("kryzen");

//   const data = contentData[selected];

//   return (
//     <div style={{ display: "flex", height: "100vh" }}>

//       {/* LEFT SIDEBAR */}
//       <div
//         style={{
//           width: "250px",
//           background: "#111",
//           color: "#fff",
//           padding: "20px",
//         }}
//       >
//         <h3>Content Systems</h3>

//         {Object.keys(contentData).map((key) => (
//           <div
//             key={key}
//             onClick={() => setSelected(key)}
//             style={{
//               padding: "10px",
//               cursor: "pointer",
//               background: selected === key ? "#333" : "transparent",
//               marginBottom: "10px",
//               borderRadius: "5px",
//             }}
//           >
//             {contentData[key].title}
//           </div>
//         ))}
//       </div>

//       {/* RIGHT CONTENT */}
//       <div style={{ flex: 1, padding: "30px", overflowY: "auto" }}>
//         <h1>{data.title}</h1>

//         {/* COLORS */}
//         <h3>🎨 Colors</h3>
//         <p>Primary: {data.colors.primary}</p>
//         <p>Secondary: {data.colors.secondary}</p>
//         <p>Accent: {data.colors.accent}</p>

//         {/* FONTS */}
//         <h3>🔤 Fonts</h3>
//         <p>Headline: {data.font.headline}</p>
//         <p>Subheading: {data.font.subheading}</p>

//         {/* FONT SIZE */}
//         <h3>📏 Font Sizes</h3>
//         <p><b>Reels:</b> Hook / Subtitle / Captions / CTA</p>
//         <p><b>Video:</b> Hook / Subtitle / Captions / CTA</p>

//         {/* LOGO */}
//         <h3>🧩 Logo Usage</h3>
//         <p>Position / Size / Opacity</p>

//         {/* VIDEO STRUCTURE */}
//         <h3>🎬 Video Structure</h3>
//         <p>
//           <b>Reel:</b> 0–3 sec → Hook → 3–20 sec → Value → 20–25 sec → CTA
//         </p>
//         <p>
//           <b>Podcast:</b> 0–30 sec Hook → Story → CTA
//         </p>
//         <p>
//           <b>Informative Video:</b> 0–30 sec Hook → Story → CTA
//         </p>

//         {/* SUBTITLE */}
//         <h3>📝 Subtitles Style</h3>
//         <ul>
//           <li>Always present</li>
//           <li>Highlight keywords</li>
//           <li>Max 2 lines</li>
//           <li>Center or bottom safe zone</li>
//         </ul>

//         {/* MUSIC */}
//         <h3>🎵 Music</h3>
//         <ul>
//           <li>Royalty free only</li>
//           <li>No copyright music</li>
//           <li>Max 25% volume</li>
//           <li>Match emotion</li>
//         </ul>

//         {/* WORKFLOW */}
//         <h3>⚙️ Workflow</h3>
//         <ol>
//           <li>Coordinator creates task</li>
//           <li>System generates Content ID</li>
//           <li>Create folder structure</li>
//           <li>Upload RAW files</li>
//           <li>Editor edits & uploads FIRST DRAFT</li>
//           <li>Coordinator reviews</li>
//           <li>Final export</li>
//         </ol>

//         {/* RULES */}
//         <h3 style={{ color: "red" }}>🚨 Non-Negotiable Rules</h3>
//         <ul>
//           <li>No overwriting files (v1 → v2 → v3)</li>
//           <li>Raw files untouched</li>
//           <li>Work only in FIRST DRAFT</li>
//           <li>Wrong naming = Rejected</li>
//         </ul>

//         {/* CTA */}
//         <h3>📢 CTA Template</h3>
//         <p>Follow / Subscribe</p>
//       </div>
//     </div>
//   );
// };

// export default CreativeStandard;

import React, { useState } from "react";
import Footer from "../../../Components/Footer/footer";
import StepRoutes from "../../../Routes/steps_routes";
import { FcBusinessman, FcImport } from "react-icons/fc";

const CreativeStandard = () => {
  const [activeTab, setActiveTab] = useState("kryzen");

  // 🔹 DATA FOR EACH LINK (DIFFERENT CONTENT)
  const contentData = {
    kryzen: {
      title: "Kryzen Biotech Guidelines",
      tables: [
        {
          heading: "Brand",
          bgColor: "#fff9db", // light yellow
          headerColor: "#f59f00", // dark yellow
          rows: [
            { label: "Name", value: "-" },
            { label: "Tagline", value: "-" },
          ],
        },
        {
          heading: "Color Schema",
          bgColor: "#fdf2e9",
          headerColor: "#fae5d3",
          rows: [
            { label: "Primary Color (Brand dominant)", value: "#f9f8f1" },
            { label: "Secondary Color", value: "#9ce349" },
            { label: "Tertiary Color", value: "#17941f" },
            { label: "Quaternary Color", value: "#b9c9d8" },
            { label: "Quinary Color", value: "#575c60" },
            { label: "Heading Font", value: "-" },
            { label: "Background Colors (Light/Dark)", value: "-" },
          ],
        },
        {
          heading: "Fonts & Text",
          bgColor: "#ebfbee",
          headerColor: "#d3f9d8",

          rows: [
            { label: "Primery Font English", value: "Lato" },
            { label: "Secondary Font English", value: "Inter" },
            { label: "Primery Font Marathi", value: "-" },
            { label: "Secondary Font Marathi", value: "-" },
            { label: "Heading Font Weight", value: "-" },
            { label: "Heading Font Size", value: "-" },
            { label: "Subheading Font", value: "-" },
            { label: "Subheading Font Weight", value: "-" },
            { label: "Subheading Font Size", value: "-" },
            { label: "Body Font", value: "-" },
            { label: "Body Font Weight", value: "-" },
            { label: "Body Font Size", value: "-" },
          ],
        },

        {
          heading: "Logo:",
          bgColor: "#f3f0ff",
          headerColor: "#e5dbff",
          rows: [
            { label: "Main logo", value: "-" },
            { label: "Icon version", value: "-" },
            { label: "White version", value: "-" },
            { label: "Black version", value: "-" },
            { label: "Animated version", value: "-" },
          ],
        },

        {
          heading: "Sublogos:",
          bgColor: "#edf2ff",
          headerColor: "#dbe4ff",
          rows: [
            { label: "खरं बोलायचं तर (Marathi Podcast)", value: "-" },
            { label: "खरा खेळ (Marathi Podcast)", value: "-" },
            { label: "अन्नदाता (Marathi Podcast)", value: "-" },
            { label: "सच की बात (Hindi Podcast)", value: "-" },
            { label: "असली खेल (Hindi Podcast)", value: "-" },
            { label: "कारोबारी किसान (Hindi Podcast)", value: "-" },
          ],
        },

        {
          heading: "Intro & Outro:",
          bgColor: "#e3fafc",
          headerColor: "#c5f6fa",
          rows: [
            { label: "Intro (Landscape)", value: "-" },
            { label: "Outro (Landscape)", value: "-" },
            { label: "Intro (Vertical)", value: "-" },
            { label: "Outro (Vertical)", value: "-" },
          ],
        },

        {
          heading: "In Video Effects:",
          bgColor: "#e6fcf5",
          headerColor: "#c3fae8",
          rows: [
            { label: "Logo placement on screen X & Y", value: "-" },
            { label: "Logo size on screen %", value: "-" },
            { label: "Location font, size and X&Y", value: "-" },
            {
              label: "Lower Thirds (Name, Position) Font, Size, X&Y",
              value: "-",
            },
            { label: "Subscriber to channel CTA", value: "-" },
            { label: "Whatsapp us CTA", value: "-" },
            { label: "Call us CTA", value: "-" },
            { label: "Podcast starting 30 sec timer (Lower Left)", value: "-" },
            { label: "Font for shorts / reels subtitle", value: "-" },
            { label: "Text Effects style for Shorts", value: "-" },
          ],
        },

        {
          heading: "Thumbnail Structure:",
          bgColor: "#f4fce3",
          headerColor: "#e9fac8",
          rows: [
            { label: "Face (emotion-driven or authority look)", value: "-" },
            { label: "3–5 words max text", value: "-" },
            { label: "High contrast background", value: "-" },
            { label: "One focal point only", value: "-" },
            { label: "No paragraph text", value: "-" },
            { label: "No clutter", value: "-" },
            { label: "Use brand colors only", value: "-" },
            { label: "Same font style always", value: "-" },
          ],
        },

        {
          heading: "Output:",
          bgColor: "#fdf2e9",
          headerColor: "#fae5d3",
          rows: [
            { label: "Landscape - 1080p", value: "-" },
            { label: "Vertical - 1080p", value: "-" },
            { label: "Landscape bitrate", value: "-" },
            { label: "Vertical bitrate", value: "-" },
          ],
        },

        {
          heading: "Inspiration channels:",
          bgColor: "#fdf2e9",
          headerColor: "#fae5d3",
          rows: [
            { label: "Edits", value: "https://www.youtube.com/@somratdutta" },
            {
              label: "Informative video",
              value: "https://www.youtube.com/@The_SaqlainKhan",
            },
            {
              label: "Podcast",
              value:
                "https://www.youtube.com/@AgriTalkbyAbhinavRoy , https://www.youtube.com/@mitramhane",
            },
            {
              label: "Style",
              value: "https://www.youtube.com/@SatvicMovement/videos",
            },
          ],
        },

        {
          heading: "Subtitles Style:",
          bgColor: "#eef7fb",
          headerColor: "#d6ecf5",
          rows: [
            {
              label: "Subtitles Style",
              value:
                "1) Always present (for reels) , 2) Highlight keywords, 3) Max 2 lines, 4) Center aligned or bottom safe zone",
            },
          ],
        },

        {
          heading: "Music:",
          bgColor: "#f0fff4",
          headerColor: "#dcfce7",
          rows: [
            {
              label: "Music",
              value:
                "1) Always royalty free background music, 2) No copyright music or background score, 3) Low volume, should not be more then 25% of Speach volume, 4) Match emotion (not random)",
            },
          ],
        },

        {
          heading: "Version Control:",
          bgColor: "#f0fdfa",
          headerColor: "#ccfbf1",
          rows: [
            {
              label: "Version Control",
              value:
                "No overwriting files. Always create versions: v1 → v2 → v3 Never replace existing files.",
            },
          ],
        },

        {
          heading: "Raw File Protection:",
          bgColor: "#fff4e6",
          headerColor: "#ffe8cc",
          rows: [
            {
              label: "Raw File Protection",
              value:
                "Raw files must remain untouched. Always create a copy before editing.",
            },
          ],
        },

        {
          heading: "Working Directory:",
          bgColor: "#f8f0fc",
          headerColor: "#f3d9fa",
          rows: [
            {
              label: "Working Directory",
              value:
                "Editors must work only inside the EDIT / FIRST DRAFT folder. No folder mixing.",
            },
          ],
        },

        {
          heading: "Workflow logic (strict flow):",
          bgColor: "#fffbea",
          headerColor: "#fff3c4",
          rows: [
            {
              label: "1",
              value:
                "Coordinator creates task (Podcast / Reel / Video / Graphics)",
            },
            { label: "2", value: "System generates a unique Content ID" },
            {
              label: "3",
              value:
                "Coordinator creates folder structure : ContentID → RAW → FIRST DRAFT → EXPORT → Reels / Video",
            },
            {
              label: "4",
              value:
                "Coordinator uploads raw footage to NAS using naming: ContentID_[1/2/3...]_RAW",
            },
            {
              label: "5",
              value:
                "Editor downloads raw files → edits locally → uploads first draft to FIRST DRAFT folder",
            },
            {
              label: "6",
              value: " Editor updates first draft link inside the task card",
            },
            {
              label: "7",
              value:
                "Coordinator reviews: 1) If changes required → sends back to editor, 2)  If approved → gives go-ahead for final",
            },
            {
              label: "8",
              value: "Editor completes final edit → uploads to EXPORT folder.",
            },
          ],
        },

        {
          heading: "Rule of the system:",
          bgColor: "#fff5f5",
          headerColor: "#ffe3e3",
          rows: [
            {
              label: "1",
              value:
                "If files are not named correctly, versioned properly, or placed in the right folder — **the work will be rejected.**",
            },
          ],
        },
      ],
    },

    hydro: {
      title: "Hydroponic Masterclass Guidelines",
      tables: [
        {
          heading: "Brand",
          bgColor: "#fff9db", // light yellow
          headerColor: "#f59f00", // dark yellow
          rows: [
            { label: "Name", value: "-" },
            { label: "Tagline", value: "-" },
          ],
        },

        {
          heading: "Color Schema",
          bgColor: "#fdf2e9",
          headerColor: "#fae5d3",
          rows: [
            { label: "Primary Color (Brand dominant)", value: "#4251c0" },
            { label: "Secondary Color", value: "#8e89be" },
            { label: "Tertiary Color", value: "#f1ecff" },
            { label: "Quaternary Color", value: "#6cbaa2" },
            { label: "Quinary Color", value: "-" },
            { label: "Heading Font", value: "-" },
            { label: "Background Colors (Light/Dark)", value: "-" },
          ],
        },

        {
          heading: "Fonts & Text",
          bgColor: "#ebfbee",
          headerColor: "#d3f9d8",

          rows: [
            { label: "Primery Font English", value: "Lato" },
            { label: "Secondary Font English", value: "Inter" },
            { label: "Primery Font Marathi", value: "-" },
            { label: "Secondary Font Marathi", value: "-" },
            { label: "Heading Font Weight", value: "-" },
            { label: "Heading Font Size", value: "-" },
            { label: "Subheading Font", value: "-" },
            { label: "Subheading Font Weight", value: "-" },
            { label: "Subheading Font Size", value: "-" },
            { label: "Body Font", value: "-" },
            { label: "Body Font Weight", value: "-" },
            { label: "Body Font Size", value: "-" },
          ],
        },

        {
          heading: "Sublogos:",
          bgColor: "#edf2ff",
          headerColor: "#dbe4ff",
          rows: [
            { label: "खरं बोलायचं तर (Marathi Podcast)", value: "-" },
            { label: "खरा खेळ (Marathi Podcast)", value: "-" },
            { label: "अन्नदाता (Marathi Podcast)", value: "-" },
            { label: "सच की बात (Hindi Podcast)", value: "-" },
            { label: "असली खेल (Hindi Podcast)", value: "-" },
            { label: "कारोबारी किसान (Hindi Podcast)", value: "-" },
          ],
        },

        {
          heading: "Intro & Outro:",
          bgColor: "#e3fafc",
          headerColor: "#c5f6fa",
          rows: [
            { label: "Intro (Landscape)", value: "-" },
            { label: "Outro (Landscape)", value: "-" },
            { label: "Intro (Vertical)", value: "-" },
            { label: "Outro (Vertical)", value: "-" },
          ],
        },

        {
          heading: "In Video Effects:",
          bgColor: "#e6fcf5",
          headerColor: "#c3fae8",
          rows: [
            { label: "Logo placement on screen X & Y", value: "-" },
            { label: "Logo size on screen %", value: "-" },
            { label: "Location font, size and X&Y", value: "-" },
            {
              label: "Lower Thirds (Name, Position) Font, Size, X&Y",
              value: "-",
            },
            { label: "Subscriber to channel CTA", value: "-" },
            { label: "Whatsapp us CTA", value: "-" },
            { label: "Call us CTA", value: "-" },
            { label: "Podcast starting 30 sec timer (Lower Left)", value: "-" },
            { label: "Font for shorts / reels subtitle", value: "-" },
            { label: "Text Effects style for Shorts", value: "-" },
          ],
        },

        {
          heading: "Thumbnail Structure:",
          bgColor: "#f4fce3",
          headerColor: "#e9fac8",
          rows: [
            { label: "Face (emotion-driven or authority look)", value: "-" },
            { label: "3–5 words max text", value: "-" },
            { label: "High contrast background", value: "-" },
            { label: "One focal point only", value: "-" },
            { label: "No paragraph text", value: "-" },
            { label: "No clutter", value: "-" },
            { label: "Use brand colors only", value: "-" },
            { label: "Same font style always", value: "-" },
          ],
        },

        {
          heading: "Output:",
          bgColor: "#fdf2e9",
          headerColor: "#fae5d3",
          rows: [
            { label: "Landscape - 1080p", value: "-" },
            { label: "Vertical - 1080p", value: "-" },
            { label: "Landscape bitrate", value: "-" },
            { label: "Vertical bitrate", value: "-" },
          ],
        },

        {
          heading: "Inspiration channels:",
          bgColor: "#fdf2e9",
          headerColor: "#fae5d3",
          rows: [
            { label: "Edits", value: "-" },
            {
              label: "Informative video",
              value: "https://www.youtube.com/@NitishRajput",
            },
            {
              label: "Podcast",
              value:
                "https://www.youtube.com/@https://www.youtube.com/watch?v=de9MIKM_FdA",
            },
            {
              label: "Style",
              value: "-",
            },
          ],
        },

        {
          heading: "Subtitles Style:",
          bgColor: "#eef7fb",
          headerColor: "#d6ecf5",
          rows: [
            {
              label: "Subtitles Style",
              value:
                "1) Always present (for reels) , 2) Highlight keywords, 3) Max 2 lines, 4) Center aligned or bottom safe zone",
            },
          ],
        },

        {
          heading: "Music:",
          bgColor: "#f0fff4",
          headerColor: "#dcfce7",
          rows: [
            {
              label: "Music",
              value:
                "1) Always royalty free background music, 2) No copyright music or background score, 3) Low volume, should not be more then 25% of Speach volume, 4) Match emotion (not random)",
            },
          ],
        },

        {
          heading: "Version Control:",
          bgColor: "#f0fdfa",
          headerColor: "#ccfbf1",
          rows: [
            {
              label: "Version Control",
              value:
                "No overwriting files. Always create versions: v1 → v2 → v3 Never replace existing files.",
            },
          ],
        },

        {
          heading: "Raw File Protection:",
          bgColor: "#fff4e6",
          headerColor: "#ffe8cc",
          rows: [
            {
              label: "Raw File Protection",
              value:
                "Raw files must remain untouched. Always create a copy before editing.",
            },
          ],
        },

        {
          heading: "Working Directory:",
          bgColor: "#f8f0fc",
          headerColor: "#f3d9fa",
          rows: [
            {
              label: "Working Directory",
              value:
                "Editors must work only inside the EDIT / FIRST DRAFT folder. No folder mixing.",
            },
          ],
        },

        {
          heading: "Workflow logic (strict flow):",
          bgColor: "#fffbea",
          headerColor: "#fff3c4",
          rows: [
            {
              label: "1",
              value:
                "Coordinator creates task (Podcast / Reel / Video / Graphics)",
            },
            { label: "2", value: "System generates a unique Content ID" },
            {
              label: "3",
              value:
                "Coordinator creates folder structure : ContentID → RAW → FIRST DRAFT → EXPORT → Reels / Video",
            },
            {
              label: "4",
              value:
                "Coordinator uploads raw footage to NAS using naming: ContentID_[1/2/3...]_RAW",
            },
            {
              label: "5",
              value:
                "Editor downloads raw files → edits locally → uploads first draft to FIRST DRAFT folder",
            },
            {
              label: "6",
              value: " Editor updates first draft link inside the task card",
            },
            {
              label: "7",
              value:
                "Coordinator reviews: 1) If changes required → sends back to editor, 2)  If approved → gives go-ahead for final",
            },
            {
              label: "8",
              value: "Editor completes final edit → uploads to EXPORT folder.",
            },
          ],
        },

        {
          heading: "Rule of the system:",
          bgColor: "#fff5f5",
          headerColor: "#ffe3e3",
          rows: [
            {
              label: "1",
              value:
                "If files are not named correctly, versioned properly, or placed in the right folder — **the work will be rejected.**",
            },
          ],
        },
      ],
    },

    sudhirMarathi: {
      title: "Sudhir Devkar Marathi",
      tables: [
        {
          heading: "Brand",
          bgColor: "#fff9db", // light yellow
          headerColor: "#f59f00", // dark yellow
          rows: [
            { label: "Name", value: "-" },
            { label: "Tagline", value: "Matitl Universe" },
          ],
        },

        {
          heading: "Color Schema",
          bgColor: "#fdf2e9",
          headerColor: "#fae5d3",
          rows: [
            { label: "Primary Color (Brand dominant)", value: "#ff9500" },
            { label: "Secondary Color", value: "#ffaa00" },
            { label: "Tertiary Color", value: "#ffc300" },
            { label: "Quaternary Color", value: "#ffdd00" },
            { label: "Quinary Color", value: "#ff002d" },
            { label: "Heading Font", value: "-" },
            { label: "Background Colors (Light/Dark)", value: "-" },
          ],
        },

        {
          heading: "Fonts & Text",
          bgColor: "#ebfbee",
          headerColor: "#d3f9d8",

          rows: [
            { label: "Primery Font English", value: "Kontora" },
            { label: "Secondary Font English", value: "Area" },
            { label: "Primery Font Marathi", value: "Peridot Devanagari" },
            { label: "Secondary Font Marathi", value: "Abacaxi Devanagari" },
            { label: "Heading Font Weight", value: "-" },
            { label: "Heading Font Size", value: "-" },
            { label: "Subheading Font", value: "-" },
            { label: "Subheading Font Weight", value: "-" },
            { label: "Subheading Font Size", value: "-" },
            { label: "Body Font", value: "-" },
            { label: "Body Font Weight", value: "-" },
            { label: "Body Font Size", value: "-" },
          ],
        },

        {
          heading: "Sublogos:",
          bgColor: "#edf2ff",
          headerColor: "#dbe4ff",
          rows: [
            { label: "खरं बोलायचं तर (Marathi Podcast)", value: "-" },
            { label: "खरा खेळ (Marathi Podcast)", value: "-" },
            { label: "अन्नदाता (Marathi Podcast)", value: "-" },
            { label: "सच की बात (Hindi Podcast)", value: "-" },
            { label: "असली खेल (Hindi Podcast)", value: "-" },
            { label: "कारोबारी किसान (Hindi Podcast)", value: "-" },
          ],
        },

        {
          heading: "Intro & Outro:",
          bgColor: "#e3fafc",
          headerColor: "#c5f6fa",
          rows: [
            { label: "Intro (Landscape)", value: "-" },
            { label: "Outro (Landscape)", value: "-" },
            { label: "Intro (Vertical)", value: "-" },
            { label: "Outro (Vertical)", value: "-" },
          ],
        },

        {
          heading: "In Video Effects:",
          bgColor: "#e6fcf5",
          headerColor: "#c3fae8",
          rows: [
            { label: "Logo placement on screen X & Y", value: "-" },
            { label: "Logo size on screen %", value: "-" },
            { label: "Location font, size and X&Y", value: "-" },
            {
              label: "Lower Thirds (Name, Position) Font, Size, X&Y",
              value: "-",
            },
            { label: "Subscriber to channel CTA", value: "-" },
            { label: "Whatsapp us CTA", value: "-" },
            { label: "Call us CTA", value: "-" },
            { label: "Podcast starting 30 sec timer (Lower Left)", value: "-" },
            { label: "Font for shorts / reels subtitle", value: "-" },
            { label: "Text Effects style for Shorts", value: "-" },
          ],
        },

        {
          heading: "Thumbnail Structure:",
          bgColor: "#f4fce3",
          headerColor: "#e9fac8",
          rows: [
            { label: "Face (emotion-driven or authority look)", value: "-" },
            { label: "3–5 words max text", value: "-" },
            { label: "High contrast background", value: "-" },
            { label: "One focal point only", value: "-" },
            { label: "No paragraph text", value: "-" },
            { label: "No clutter", value: "-" },
            { label: "Use brand colors only", value: "-" },
            { label: "Same font style always", value: "-" },
          ],
        },

        {
          heading: "Output:",
          bgColor: "#fdf2e9",
          headerColor: "#fae5d3",
          rows: [
            { label: "Landscape - 1080p", value: "-" },
            { label: "Vertical - 1080p", value: "-" },
            { label: "Landscape bitrate", value: "-" },
            { label: "Vertical bitrate", value: "-" },
          ],
        },

        {
          heading: "Inspiration channels:",
          bgColor: "#fdf2e9",
          headerColor: "#fae5d3",
          rows: [
            { label: "Edits", value: "-" },
            {
              label: "Informative video",
              value: "https://www.youtube.com/@aevytv",
            },
            {
              label: "Podcast",
              value:
                "-",
            },
            {
              label: "Style",
              value: "-",
            },
          ],
        },

        {
          heading: "Subtitles Style:",
          bgColor: "#eef7fb",
          headerColor: "#d6ecf5",
          rows: [
            {
              label: "Subtitles Style",
              value:
                "1) Always present (for reels) , 2) Highlight keywords, 3) Max 2 lines, 4) Center aligned or bottom safe zone",
            },
          ],
        },

        {
          heading: "Music:",
          bgColor: "#f0fff4",
          headerColor: "#dcfce7",
          rows: [
            {
              label: "Music",
              value:
                "1) Always royalty free background music, 2) No copyright music or background score, 3) Low volume, should not be more then 25% of Speach volume, 4) Match emotion (not random)",
            },
          ],
        },

        {
          heading: "Version Control:",
          bgColor: "#f0fdfa",
          headerColor: "#ccfbf1",
          rows: [
            {
              label: "Version Control",
              value:
                "No overwriting files. Always create versions: v1 → v2 → v3 Never replace existing files.",
            },
          ],
        },

        {
          heading: "Raw File Protection:",
          bgColor: "#fff4e6",
          headerColor: "#ffe8cc",
          rows: [
            {
              label: "Raw File Protection",
              value:
                "Raw files must remain untouched. Always create a copy before editing.",
            },
          ],
        },

        {
          heading: "Working Directory:",
          bgColor: "#f8f0fc",
          headerColor: "#f3d9fa",
          rows: [
            {
              label: "Working Directory",
              value:
                "Editors must work only inside the EDIT / FIRST DRAFT folder. No folder mixing.",
            },
          ],
        },

        {
          heading: "Workflow logic (strict flow):",
          bgColor: "#fffbea",
          headerColor: "#fff3c4",
          rows: [
            {
              label: "1",
              value:
                "Coordinator creates task (Podcast / Reel / Video / Graphics)",
            },
            { label: "2", value: "System generates a unique Content ID" },
            {
              label: "3",
              value:
                "Coordinator creates folder structure : ContentID → RAW → FIRST DRAFT → EXPORT → Reels / Video",
            },
            {
              label: "4",
              value:
                "Coordinator uploads raw footage to NAS using naming: ContentID_[1/2/3...]_RAW",
            },
            {
              label: "5",
              value:
                "Editor downloads raw files → edits locally → uploads first draft to FIRST DRAFT folder",
            },
            {
              label: "6",
              value: " Editor updates first draft link inside the task card",
            },
            {
              label: "7",
              value:
                "Coordinator reviews: 1) If changes required → sends back to editor, 2)  If approved → gives go-ahead for final",
            },
            {
              label: "8",
              value: "Editor completes final edit → uploads to EXPORT folder.",
            },
          ],
        },

        {
          heading: "Rule of the system:",
          bgColor: "#fff5f5",
          headerColor: "#ffe3e3",
          rows: [
            {
              label: "1",
              value:
                "If files are not named correctly, versioned properly, or placed in the right folder — **the work will be rejected.**",
            },
          ],
        },
      ],
    },

    sudhirHindi: {
      title: "Sudhir Devkar Hindi",
      tables: [
        {
          heading: "Brand",
          bgColor: "#fff9db", // light yellow
          headerColor: "#f59f00", // dark yellow
          rows: [
            { label: "Name", value: "-" },
            { label: "Tagline", value: "Mitiki Diniya/ Mittika Universe" },
          ],
        },

        {
          heading: "Color Schema",
          bgColor: "#fdf2e9",
          headerColor: "#fae5d3",
          rows: [
            { label: "Primary Color (Brand dominant)", value: "#ff9500" },
            { label: "Secondary Color", value: "#ffaa00" },
            { label: "Tertiary Color", value: "#ffc300" },
            { label: "Quaternary Color", value: "#ffdd00" },
            { label: "Quinary Color", value: "#ff002d" },
            { label: "Heading Font", value: "-" },
            { label: "Background Colors (Light/Dark)", value: "-" },
          ],
        },

        {
          heading: "Fonts & Text",
          bgColor: "#ebfbee",
          headerColor: "#d3f9d8",

          rows: [
            { label: "Primery Font English", value: "Kontora" },
            { label: "Secondary Font English", value: "Area" },
            { label: "Primery Font Marathi", value: "Peridot Devanagari" },
            { label: "Secondary Font Marathi", value: "Abacaxi Devanagari" },
            { label: "Heading Font Weight", value: "-" },
            { label: "Heading Font Size", value: "-" },
            { label: "Subheading Font", value: "-" },
            { label: "Subheading Font Weight", value: "-" },
            { label: "Subheading Font Size", value: "-" },
            { label: "Body Font", value: "-" },
            { label: "Body Font Weight", value: "-" },
            { label: "Body Font Size", value: "-" },
          ],
        },

        {
          heading: "Sublogos:",
          bgColor: "#edf2ff",
          headerColor: "#dbe4ff",
          rows: [
            { label: "खरं बोलायचं तर (Marathi Podcast)", value: "-" },
            { label: "खरा खेळ (Marathi Podcast)", value: "-" },
            { label: "अन्नदाता (Marathi Podcast)", value: "-" },
            { label: "सच की बात (Hindi Podcast)", value: "-" },
            { label: "असली खेल (Hindi Podcast)", value: "-" },
            { label: "कारोबारी किसान (Hindi Podcast)", value: "-" },
          ],
        },

        {
          heading: "Intro & Outro:",
          bgColor: "#e3fafc",
          headerColor: "#c5f6fa",
          rows: [
            { label: "Intro (Landscape)", value: "-" },
            { label: "Outro (Landscape)", value: "-" },
            { label: "Intro (Vertical)", value: "-" },
            { label: "Outro (Vertical)", value: "-" },
          ],
        },

        {
          heading: "In Video Effects:",
          bgColor: "#e6fcf5",
          headerColor: "#c3fae8",
          rows: [
            { label: "Logo placement on screen X & Y", value: "-" },
            { label: "Logo size on screen %", value: "-" },
            { label: "Location font, size and X&Y", value: "-" },
            {
              label: "Lower Thirds (Name, Position) Font, Size, X&Y",
              value: "-",
            },
            { label: "Subscriber to channel CTA", value: "-" },
            { label: "Whatsapp us CTA", value: "-" },
            { label: "Call us CTA", value: "-" },
            { label: "Podcast starting 30 sec timer (Lower Left)", value: "-" },
            { label: "Font for shorts / reels subtitle", value: "-" },
            { label: "Text Effects style for Shorts", value: "-" },
          ],
        },

        {
          heading: "Thumbnail Structure:",
          bgColor: "#f4fce3",
          headerColor: "#e9fac8",
          rows: [
            { label: "Face (emotion-driven or authority look)", value: "-" },
            { label: "3–5 words max text", value: "-" },
            { label: "High contrast background", value: "-" },
            { label: "One focal point only", value: "-" },
            { label: "No paragraph text", value: "-" },
            { label: "No clutter", value: "-" },
            { label: "Use brand colors only", value: "-" },
            { label: "Same font style always", value: "-" },
          ],
        },

        {
          heading: "Output:",
          bgColor: "#fdf2e9",
          headerColor: "#fae5d3",
          rows: [
            { label: "Landscape - 1080p", value: "-" },
            { label: "Vertical - 1080p", value: "-" },
            { label: "Landscape bitrate", value: "-" },
            { label: "Vertical bitrate", value: "-" },
          ],
        },

        {
          heading: "Inspiration channels:",
          bgColor: "#fdf2e9",
          headerColor: "#fae5d3",
          rows: [
            { label: "Edits", value: "-" },
            {
              label: "Informative video",
              value: "https://www.youtube.com/@aevytv",
            },
            {
              label: "Podcast",
              value:
                "-",
            },
            {
              label: "Style",
              value: "-",
            },
          ],
        },

        {
          heading: "Subtitles Style:",
          bgColor: "#eef7fb",
          headerColor: "#d6ecf5",
          rows: [
            {
              label: "Subtitles Style",
              value:
                "1) Always present (for reels) , 2) Highlight keywords, 3) Max 2 lines, 4) Center aligned or bottom safe zone",
            },
          ],
        },

        {
          heading: "Music:",
          bgColor: "#f0fff4",
          headerColor: "#dcfce7",
          rows: [
            {
              label: "Music",
              value:
                "1) Always royalty free background music, 2) No copyright music or background score, 3) Low volume, should not be more then 25% of Speach volume, 4) Match emotion (not random)",
            },
          ],
        },

        {
          heading: "Version Control:",
          bgColor: "#f0fdfa",
          headerColor: "#ccfbf1",
          rows: [
            {
              label: "Version Control",
              value:
                "No overwriting files. Always create versions: v1 → v2 → v3 Never replace existing files.",
            },
          ],
        },

        {
          heading: "Raw File Protection:",
          bgColor: "#fff4e6",
          headerColor: "#ffe8cc",
          rows: [
            {
              label: "Raw File Protection",
              value:
                "Raw files must remain untouched. Always create a copy before editing.",
            },
          ],
        },

        {
          heading: "Working Directory:",
          bgColor: "#f8f0fc",
          headerColor: "#f3d9fa",
          rows: [
            {
              label: "Working Directory",
              value:
                "Editors must work only inside the EDIT / FIRST DRAFT folder. No folder mixing.",
            },
          ],
        },

        {
          heading: "Workflow logic (strict flow):",
          bgColor: "#fffbea",
          headerColor: "#fff3c4",
          rows: [
            {
              label: "1",
              value:
                "Coordinator creates task (Podcast / Reel / Video / Graphics)",
            },
            { label: "2", value: "System generates a unique Content ID" },
            {
              label: "3",
              value:
                "Coordinator creates folder structure : ContentID → RAW → FIRST DRAFT → EXPORT → Reels / Video",
            },
            {
              label: "4",
              value:
                "Coordinator uploads raw footage to NAS using naming: ContentID_[1/2/3...]_RAW",
            },
            {
              label: "5",
              value:
                "Editor downloads raw files → edits locally → uploads first draft to FIRST DRAFT folder",
            },
            {
              label: "6",
              value: " Editor updates first draft link inside the task card",
            },
            {
              label: "7",
              value:
                "Coordinator reviews: 1) If changes required → sends back to editor, 2)  If approved → gives go-ahead for final",
            },
            {
              label: "8",
              value: "Editor completes final edit → uploads to EXPORT folder.",
            },
          ],
        },

        {
          heading: "Rule of the system:",
          bgColor: "#fff5f5",
          headerColor: "#ffe3e3",
          rows: [
            {
              label: "1",
              value:
                "If files are not named correctly, versioned properly, or placed in the right folder — **the work will be rejected.**",
            },
          ],
        },
      ],
    },

  
    sudhirMarathiClips: {
      title: "Sudhir Devkar Marathi Clips",
      tables: [
        {
          heading: "Brand",
          bgColor: "#fff9db", // light yellow
          headerColor: "#f59f00", // dark yellow
          rows: [
            { label: "Name", value: "-" },
            { label: "Tagline", value: "-" },
          ],
        },

        {
          heading: "Color Schema",
          bgColor: "#fdf2e9",
          headerColor: "#fae5d3",
          rows: [
            { label: "Primary Color (Brand dominant)", value: "#ff9500" },
            { label: "Secondary Color", value: "#ffaa00" },
            { label: "Tertiary Color", value: "#ffc300" },
            { label: "Quaternary Color", value: "#ffdd00" },
            { label: "Quinary Color", value: "#ff002d" },
            { label: "Heading Font", value: "-" },
            { label: "Background Colors (Light/Dark)", value: "-" },
          ],
        },

        {
          heading: "Fonts & Text",
          bgColor: "#ebfbee",
          headerColor: "#d3f9d8",

          rows: [
            { label: "Primery Font English", value: "Kontora" },
            { label: "Secondary Font English", value: "Area" },
            { label: "Primery Font Marathi", value: "Peridot Devanagari" },
            { label: "Secondary Font Marathi", value: "Abacaxi Devanagari" },
            { label: "Heading Font Weight", value: "-" },
            { label: "Heading Font Size", value: "-" },
            { label: "Subheading Font", value: "-" },
            { label: "Subheading Font Weight", value: "-" },
            { label: "Subheading Font Size", value: "-" },
            { label: "Body Font", value: "-" },
            { label: "Body Font Weight", value: "-" },
            { label: "Body Font Size", value: "-" },
          ],
        },

        {
          heading: "Sublogos:",
          bgColor: "#edf2ff",
          headerColor: "#dbe4ff",
          rows: [
            { label: "खरं बोलायचं तर (Marathi Podcast)", value: "-" },
            { label: "खरा खेळ (Marathi Podcast)", value: "-" },
            { label: "अन्नदाता (Marathi Podcast)", value: "-" },
            { label: "सच की बात (Hindi Podcast)", value: "-" },
            { label: "असली खेल (Hindi Podcast)", value: "-" },
            { label: "कारोबारी किसान (Hindi Podcast)", value: "-" },
          ],
        },

        {
          heading: "Intro & Outro:",
          bgColor: "#e3fafc",
          headerColor: "#c5f6fa",
          rows: [
            { label: "Intro (Landscape)", value: "-" },
            { label: "Outro (Landscape)", value: "-" },
            { label: "Intro (Vertical)", value: "-" },
            { label: "Outro (Vertical)", value: "-" },
          ],
        },

        {
          heading: "In Video Effects:",
          bgColor: "#e6fcf5",
          headerColor: "#c3fae8",
          rows: [
            { label: "Logo placement on screen X & Y", value: "-" },
            { label: "Logo size on screen %", value: "-" },
            { label: "Location font, size and X&Y", value: "-" },
            {
              label: "Lower Thirds (Name, Position) Font, Size, X&Y",
              value: "-",
            },
            { label: "Subscriber to channel CTA", value: "-" },
            { label: "Whatsapp us CTA", value: "-" },
            { label: "Call us CTA", value: "-" },
            { label: "Podcast starting 30 sec timer (Lower Left)", value: "-" },
            { label: "Font for shorts / reels subtitle", value: "-" },
            { label: "Text Effects style for Shorts", value: "-" },
          ],
        },

        {
          heading: "Thumbnail Structure:",
          bgColor: "#f4fce3",
          headerColor: "#e9fac8",
          rows: [
            { label: "Face (emotion-driven or authority look)", value: "-" },
            { label: "3–5 words max text", value: "-" },
            { label: "High contrast background", value: "-" },
            { label: "One focal point only", value: "-" },
            { label: "No paragraph text", value: "-" },
            { label: "No clutter", value: "-" },
            { label: "Use brand colors only", value: "-" },
            { label: "Same font style always", value: "-" },
          ],
        },

        {
          heading: "Output:",
          bgColor: "#fdf2e9",
          headerColor: "#fae5d3",
          rows: [
            { label: "Landscape - 1080p", value: "-" },
            { label: "Vertical - 1080p", value: "-" },
            { label: "Landscape bitrate", value: "-" },
            { label: "Vertical bitrate", value: "-" },
          ],
        },

        {
          heading: "Inspiration channels:",
          bgColor: "#fdf2e9",
          headerColor: "#fae5d3",
          rows: [
            { label: "Edits", value: "-" },
            {
              label: "Informative video",
              value: "https://www.youtube.com/@aevytv",
            },
            {
              label: "Podcast",
              value:
                "-",
            },
            {
              label: "Style",
              value: "-",
            },
          ],
        },

        {
          heading: "Subtitles Style:",
          bgColor: "#eef7fb",
          headerColor: "#d6ecf5",
          rows: [
            {
              label: "Subtitles Style",
              value:
                "1) Always present (for reels) , 2) Highlight keywords, 3) Max 2 lines, 4) Center aligned or bottom safe zone",
            },
          ],
        },

        {
          heading: "Music:",
          bgColor: "#f0fff4",
          headerColor: "#dcfce7",
          rows: [
            {
              label: "Music",
              value:
                "1) Always royalty free background music, 2) No copyright music or background score, 3) Low volume, should not be more then 25% of Speach volume, 4) Match emotion (not random)",
            },
          ],
        },

        {
          heading: "Version Control:",
          bgColor: "#f0fdfa",
          headerColor: "#ccfbf1",
          rows: [
            {
              label: "Version Control",
              value:
                "No overwriting files. Always create versions: v1 → v2 → v3 Never replace existing files.",
            },
          ],
        },

        {
          heading: "Raw File Protection:",
          bgColor: "#fff4e6",
          headerColor: "#ffe8cc",
          rows: [
            {
              label: "Raw File Protection",
              value:
                "Raw files must remain untouched. Always create a copy before editing.",
            },
          ],
        },

        {
          heading: "Working Directory:",
          bgColor: "#f8f0fc",
          headerColor: "#f3d9fa",
          rows: [
            {
              label: "Working Directory",
              value:
                "Editors must work only inside the EDIT / FIRST DRAFT folder. No folder mixing.",
            },
          ],
        },

        {
          heading: "Workflow logic (strict flow):",
          bgColor: "#fffbea",
          headerColor: "#fff3c4",
          rows: [
            {
              label: "1",
              value:
                "Coordinator creates task (Podcast / Reel / Video / Graphics)",
            },
            { label: "2", value: "System generates a unique Content ID" },
            {
              label: "3",
              value:
                "Coordinator creates folder structure : ContentID → RAW → FIRST DRAFT → EXPORT → Reels / Video",
            },
            {
              label: "4",
              value:
                "Coordinator uploads raw footage to NAS using naming: ContentID_[1/2/3...]_RAW",
            },
            {
              label: "5",
              value:
                "Editor downloads raw files → edits locally → uploads first draft to FIRST DRAFT folder",
            },
            {
              label: "6",
              value: " Editor updates first draft link inside the task card",
            },
            {
              label: "7",
              value:
                "Coordinator reviews: 1) If changes required → sends back to editor, 2)  If approved → gives go-ahead for final",
            },
            {
              label: "8",
              value: "Editor completes final edit → uploads to EXPORT folder.",
            },
          ],
        },

        {
          heading: "Rule of the system:",
          bgColor: "#fff5f5",
          headerColor: "#ffe3e3",
          rows: [
            {
              label: "1",
              value:
                "If files are not named correctly, versioned properly, or placed in the right folder — **the work will be rejected.**",
            },
          ],
        },
      ],
    },

    sudhirHindiClips: {
      title: "Sudhir Devkar Hindi Clips",
      tables: [
        {
          heading: "Brand",
          bgColor: "#fff9db", // light yellow
          headerColor: "#f59f00", // dark yellow
          rows: [
            { label: "Name", value: "-" },
            { label: "Tagline", value: "-" },
          ],
        },

        {
          heading: "Color Schema",
          bgColor: "#fdf2e9",
          headerColor: "#fae5d3",
          rows: [
            { label: "Primary Color (Brand dominant)", value: "#ff9500" },
            { label: "Secondary Color", value: "#ffaa00" },
            { label: "Tertiary Color", value: "#ffc300" },
            { label: "Quaternary Color", value: "#ffdd00" },
            { label: "Quinary Color", value: "#ff002d" },
            { label: "Heading Font", value: "-" },
            { label: "Background Colors (Light/Dark)", value: "-" },
          ],
        },

        {
          heading: "Fonts & Text",
          bgColor: "#ebfbee",
          headerColor: "#d3f9d8",

          rows: [
            { label: "Primery Font English", value: "Kontora" },
            { label: "Secondary Font English", value: "Area" },
            { label: "Primery Font Marathi", value: "Peridot Devanagari" },
            { label: "Secondary Font Marathi", value: "Abacaxi Devanagari" },
            { label: "Heading Font Weight", value: "-" },
            { label: "Heading Font Size", value: "-" },
            { label: "Subheading Font", value: "-" },
            { label: "Subheading Font Weight", value: "-" },
            { label: "Subheading Font Size", value: "-" },
            { label: "Body Font", value: "-" },
            { label: "Body Font Weight", value: "-" },
            { label: "Body Font Size", value: "-" },
          ],
        },

        {
          heading: "Sublogos:",
          bgColor: "#edf2ff",
          headerColor: "#dbe4ff",
          rows: [
            { label: "खरं बोलायचं तर (Marathi Podcast)", value: "-" },
            { label: "खरा खेळ (Marathi Podcast)", value: "-" },
            { label: "अन्नदाता (Marathi Podcast)", value: "-" },
            { label: "सच की बात (Hindi Podcast)", value: "-" },
            { label: "असली खेल (Hindi Podcast)", value: "-" },
            { label: "कारोबारी किसान (Hindi Podcast)", value: "-" },
          ],
        },

        {
          heading: "Intro & Outro:",
          bgColor: "#e3fafc",
          headerColor: "#c5f6fa",
          rows: [
            { label: "Intro (Landscape)", value: "-" },
            { label: "Outro (Landscape)", value: "-" },
            { label: "Intro (Vertical)", value: "-" },
            { label: "Outro (Vertical)", value: "-" },
          ],
        },

        {
          heading: "In Video Effects:",
          bgColor: "#e6fcf5",
          headerColor: "#c3fae8",
          rows: [
            { label: "Logo placement on screen X & Y", value: "-" },
            { label: "Logo size on screen %", value: "-" },
            { label: "Location font, size and X&Y", value: "-" },
            {
              label: "Lower Thirds (Name, Position) Font, Size, X&Y",
              value: "-",
            },
            { label: "Subscriber to channel CTA", value: "-" },
            { label: "Whatsapp us CTA", value: "-" },
            { label: "Call us CTA", value: "-" },
            { label: "Podcast starting 30 sec timer (Lower Left)", value: "-" },
            { label: "Font for shorts / reels subtitle", value: "-" },
            { label: "Text Effects style for Shorts", value: "-" },
          ],
        },

        {
          heading: "Thumbnail Structure:",
          bgColor: "#f4fce3",
          headerColor: "#e9fac8",
          rows: [
            { label: "Face (emotion-driven or authority look)", value: "-" },
            { label: "3–5 words max text", value: "-" },
            { label: "High contrast background", value: "-" },
            { label: "One focal point only", value: "-" },
            { label: "No paragraph text", value: "-" },
            { label: "No clutter", value: "-" },
            { label: "Use brand colors only", value: "-" },
            { label: "Same font style always", value: "-" },
          ],
        },

        {
          heading: "Output:",
          bgColor: "#fdf2e9",
          headerColor: "#fae5d3",
          rows: [
            { label: "Landscape - 1080p", value: "-" },
            { label: "Vertical - 1080p", value: "-" },
            { label: "Landscape bitrate", value: "-" },
            { label: "Vertical bitrate", value: "-" },
          ],
        },

        {
          heading: "Inspiration channels:",
          bgColor: "#fdf2e9",
          headerColor: "#fae5d3",
          rows: [
            { label: "Edits", value: "-" },
            {
              label: "Informative video",
              value: "https://www.youtube.com/@aevytv",
            },
            {
              label: "Podcast",
              value:
                "-",
            },
            {
              label: "Style",
              value: "-",
            },
          ],
        },

        {
          heading: "Subtitles Style:",
          bgColor: "#eef7fb",
          headerColor: "#d6ecf5",
          rows: [
            {
              label: "Subtitles Style",
              value:
                "1) Always present (for reels) , 2) Highlight keywords, 3) Max 2 lines, 4) Center aligned or bottom safe zone",
            },
          ],
        },

        {
          heading: "Music:",
          bgColor: "#f0fff4",
          headerColor: "#dcfce7",
          rows: [
            {
              label: "Music",
              value:
                "1) Always royalty free background music, 2) No copyright music or background score, 3) Low volume, should not be more then 25% of Speach volume, 4) Match emotion (not random)",
            },
          ],
        },

        {
          heading: "Version Control:",
          bgColor: "#f0fdfa",
          headerColor: "#ccfbf1",
          rows: [
            {
              label: "Version Control",
              value:
                "No overwriting files. Always create versions: v1 → v2 → v3 Never replace existing files.",
            },
          ],
        },

        {
          heading: "Raw File Protection:",
          bgColor: "#fff4e6",
          headerColor: "#ffe8cc",
          rows: [
            {
              label: "Raw File Protection",
              value:
                "Raw files must remain untouched. Always create a copy before editing.",
            },
          ],
        },

        {
          heading: "Working Directory:",
          bgColor: "#f8f0fc",
          headerColor: "#f3d9fa",
          rows: [
            {
              label: "Working Directory",
              value:
                "Editors must work only inside the EDIT / FIRST DRAFT folder. No folder mixing.",
            },
          ],
        },

        {
          heading: "Workflow logic (strict flow):",
          bgColor: "#fffbea",
          headerColor: "#fff3c4",
          rows: [
            {
              label: "1",
              value:
                "Coordinator creates task (Podcast / Reel / Video / Graphics)",
            },
            { label: "2", value: "System generates a unique Content ID" },
            {
              label: "3",
              value:
                "Coordinator creates folder structure : ContentID → RAW → FIRST DRAFT → EXPORT → Reels / Video",
            },
            {
              label: "4",
              value:
                "Coordinator uploads raw footage to NAS using naming: ContentID_[1/2/3...]_RAW",
            },
            {
              label: "5",
              value:
                "Editor downloads raw files → edits locally → uploads first draft to FIRST DRAFT folder",
            },
            {
              label: "6",
              value: " Editor updates first draft link inside the task card",
            },
            {
              label: "7",
              value:
                "Coordinator reviews: 1) If changes required → sends back to editor, 2)  If approved → gives go-ahead for final",
            },
            {
              label: "8",
              value: "Editor completes final edit → uploads to EXPORT folder.",
            },
          ],
        },

        {
          heading: "Rule of the system:",
          bgColor: "#fff5f5",
          headerColor: "#ffe3e3",
          rows: [
            {
              label: "1",
              value:
                "If files are not named correctly, versioned properly, or placed in the right folder — **the work will be rejected.**",
            },
          ],
        },
      ],
    },


    sudhirMarathiShorts: {
      title: "Sudhir Devkar Marathi Shorts",
      tables: [
        {
          heading: "Brand",
          bgColor: "#fff9db", // light yellow
          headerColor: "#f59f00", // dark yellow
          rows: [
            { label: "Name", value: "-" },
            { label: "Tagline", value: "-" },
          ],
        },

        {
          heading: "Color Schema",
          bgColor: "#fdf2e9",
          headerColor: "#fae5d3",
          rows: [
            { label: "Primary Color (Brand dominant)", value: "#ff9500" },
            { label: "Secondary Color", value: "#ffaa00" },
            { label: "Tertiary Color", value: "#ffc300" },
            { label: "Quaternary Color", value: "#ffdd00" },
            { label: "Quinary Color", value: "#ff002d" },
            { label: "Heading Font", value: "-" },
            { label: "Background Colors (Light/Dark)", value: "-" },
          ],
        },

        {
          heading: "Fonts & Text",
          bgColor: "#ebfbee",
          headerColor: "#d3f9d8",

          rows: [
            { label: "Primery Font English", value: "Kontora" },
            { label: "Secondary Font English", value: "Area" },
            { label: "Primery Font Marathi", value: "Peridot Devanagari" },
            { label: "Secondary Font Marathi", value: "Abacaxi Devanagari" },
            { label: "Heading Font Weight", value: "-" },
            { label: "Heading Font Size", value: "-" },
            { label: "Subheading Font", value: "-" },
            { label: "Subheading Font Weight", value: "-" },
            { label: "Subheading Font Size", value: "-" },
            { label: "Body Font", value: "-" },
            { label: "Body Font Weight", value: "-" },
            { label: "Body Font Size", value: "-" },
          ],
        },

        {
          heading: "Sublogos:",
          bgColor: "#edf2ff",
          headerColor: "#dbe4ff",
          rows: [
            { label: "खरं बोलायचं तर (Marathi Podcast)", value: "-" },
            { label: "खरा खेळ (Marathi Podcast)", value: "-" },
            { label: "अन्नदाता (Marathi Podcast)", value: "-" },
            { label: "सच की बात (Hindi Podcast)", value: "-" },
            { label: "असली खेल (Hindi Podcast)", value: "-" },
            { label: "कारोबारी किसान (Hindi Podcast)", value: "-" },
          ],
        },

        {
          heading: "Intro & Outro:",
          bgColor: "#e3fafc",
          headerColor: "#c5f6fa",
          rows: [
            { label: "Intro (Landscape)", value: "-" },
            { label: "Outro (Landscape)", value: "-" },
            { label: "Intro (Vertical)", value: "-" },
            { label: "Outro (Vertical)", value: "-" },
          ],
        },

        {
          heading: "In Video Effects:",
          bgColor: "#e6fcf5",
          headerColor: "#c3fae8",
          rows: [
            { label: "Logo placement on screen X & Y", value: "-" },
            { label: "Logo size on screen %", value: "-" },
            { label: "Location font, size and X&Y", value: "-" },
            {
              label: "Lower Thirds (Name, Position) Font, Size, X&Y",
              value: "-",
            },
            { label: "Subscriber to channel CTA", value: "-" },
            { label: "Whatsapp us CTA", value: "-" },
            { label: "Call us CTA", value: "-" },
            { label: "Podcast starting 30 sec timer (Lower Left)", value: "-" },
            { label: "Font for shorts / reels subtitle", value: "-" },
            { label: "Text Effects style for Shorts", value: "-" },
          ],
        },

        {
          heading: "Thumbnail Structure:",
          bgColor: "#f4fce3",
          headerColor: "#e9fac8",
          rows: [
            { label: "Face (emotion-driven or authority look)", value: "-" },
            { label: "3–5 words max text", value: "-" },
            { label: "High contrast background", value: "-" },
            { label: "One focal point only", value: "-" },
            { label: "No paragraph text", value: "-" },
            { label: "No clutter", value: "-" },
            { label: "Use brand colors only", value: "-" },
            { label: "Same font style always", value: "-" },
          ],
        },

        {
          heading: "Output:",
          bgColor: "#fdf2e9",
          headerColor: "#fae5d3",
          rows: [
            { label: "Landscape - 1080p", value: "-" },
            { label: "Vertical - 1080p", value: "-" },
            { label: "Landscape bitrate", value: "-" },
            { label: "Vertical bitrate", value: "-" },
          ],
        },

        {
          heading: "Inspiration channels:",
          bgColor: "#fdf2e9",
          headerColor: "#fae5d3",
          rows: [
            { label: "Edits", value: "-" },
            {
              label: "Informative video",
              value: "https://www.youtube.com/@aevytv",
            },
            {
              label: "Podcast",
              value:
                "-",
            },
            {
              label: "Style",
              value: "-",
            },
          ],
        },

        {
          heading: "Subtitles Style:",
          bgColor: "#eef7fb",
          headerColor: "#d6ecf5",
          rows: [
            {
              label: "Subtitles Style",
              value:
                "1) Always present (for reels) , 2) Highlight keywords, 3) Max 2 lines, 4) Center aligned or bottom safe zone",
            },
          ],
        },

        {
          heading: "Music:",
          bgColor: "#f0fff4",
          headerColor: "#dcfce7",
          rows: [
            {
              label: "Music",
              value:
                "1) Always royalty free background music, 2) No copyright music or background score, 3) Low volume, should not be more then 25% of Speach volume, 4) Match emotion (not random)",
            },
          ],
        },

        {
          heading: "Version Control:",
          bgColor: "#f0fdfa",
          headerColor: "#ccfbf1",
          rows: [
            {
              label: "Version Control",
              value:
                "No overwriting files. Always create versions: v1 → v2 → v3 Never replace existing files.",
            },
          ],
        },

        {
          heading: "Raw File Protection:",
          bgColor: "#fff4e6",
          headerColor: "#ffe8cc",
          rows: [
            {
              label: "Raw File Protection",
              value:
                "Raw files must remain untouched. Always create a copy before editing.",
            },
          ],
        },

        {
          heading: "Working Directory:",
          bgColor: "#f8f0fc",
          headerColor: "#f3d9fa",
          rows: [
            {
              label: "Working Directory",
              value:
                "Editors must work only inside the EDIT / FIRST DRAFT folder. No folder mixing.",
            },
          ],
        },

        {
          heading: "Workflow logic (strict flow):",
          bgColor: "#fffbea",
          headerColor: "#fff3c4",
          rows: [
            {
              label: "1",
              value:
                "Coordinator creates task (Podcast / Reel / Video / Graphics)",
            },
            { label: "2", value: "System generates a unique Content ID" },
            {
              label: "3",
              value:
                "Coordinator creates folder structure : ContentID → RAW → FIRST DRAFT → EXPORT → Reels / Video",
            },
            {
              label: "4",
              value:
                "Coordinator uploads raw footage to NAS using naming: ContentID_[1/2/3...]_RAW",
            },
            {
              label: "5",
              value:
                "Editor downloads raw files → edits locally → uploads first draft to FIRST DRAFT folder",
            },
            {
              label: "6",
              value: " Editor updates first draft link inside the task card",
            },
            {
              label: "7",
              value:
                "Coordinator reviews: 1) If changes required → sends back to editor, 2)  If approved → gives go-ahead for final",
            },
            {
              label: "8",
              value: "Editor completes final edit → uploads to EXPORT folder.",
            },
          ],
        },

        {
          heading: "Rule of the system:",
          bgColor: "#fff5f5",
          headerColor: "#ffe3e3",
          rows: [
            {
              label: "1",
              value:
                "If files are not named correctly, versioned properly, or placed in the right folder — **the work will be rejected.**",
            },
          ],
        },
      ],
    },

    sudhirHindiShorts: {
      title: "Sudhir Devkar Hindi Shorts",
      tables: [
        {
          heading: "Brand",
          bgColor: "#fff9db", // light yellow
          headerColor: "#f59f00", // dark yellow
          rows: [
            { label: "Name", value: "-" },
            { label: "Tagline", value: "-" },
          ],
        },

        {
          heading: "Color Schema",
          bgColor: "#fdf2e9",
          headerColor: "#fae5d3",
          rows: [
            { label: "Primary Color (Brand dominant)", value: "#ff9500" },
            { label: "Secondary Color", value: "#ffaa00" },
            { label: "Tertiary Color", value: "#ffc300" },
            { label: "Quaternary Color", value: "#ffdd00" },
            { label: "Quinary Color", value: "#ff002d" },
            { label: "Heading Font", value: "-" },
            { label: "Background Colors (Light/Dark)", value: "-" },
          ],
        },

        {
          heading: "Fonts & Text",
          bgColor: "#ebfbee",
          headerColor: "#d3f9d8",

          rows: [
            { label: "Primery Font English", value: "Kontora" },
            { label: "Secondary Font English", value: "Area" },
            { label: "Primery Font Marathi", value: "Peridot Devanagari" },
            { label: "Secondary Font Marathi", value: "Abacaxi Devanagari" },
            { label: "Heading Font Weight", value: "-" },
            { label: "Heading Font Size", value: "-" },
            { label: "Subheading Font", value: "-" },
            { label: "Subheading Font Weight", value: "-" },
            { label: "Subheading Font Size", value: "-" },
            { label: "Body Font", value: "-" },
            { label: "Body Font Weight", value: "-" },
            { label: "Body Font Size", value: "-" },
          ],
        },

        {
          heading: "Sublogos:",
          bgColor: "#edf2ff",
          headerColor: "#dbe4ff",
          rows: [
            { label: "खरं बोलायचं तर (Marathi Podcast)", value: "-" },
            { label: "खरा खेळ (Marathi Podcast)", value: "-" },
            { label: "अन्नदाता (Marathi Podcast)", value: "-" },
            { label: "सच की बात (Hindi Podcast)", value: "-" },
            { label: "असली खेल (Hindi Podcast)", value: "-" },
            { label: "कारोबारी किसान (Hindi Podcast)", value: "-" },
          ],
        },

        {
          heading: "Intro & Outro:",
          bgColor: "#e3fafc",
          headerColor: "#c5f6fa",
          rows: [
            { label: "Intro (Landscape)", value: "-" },
            { label: "Outro (Landscape)", value: "-" },
            { label: "Intro (Vertical)", value: "-" },
            { label: "Outro (Vertical)", value: "-" },
          ],
        },

        {
          heading: "In Video Effects:",
          bgColor: "#e6fcf5",
          headerColor: "#c3fae8",
          rows: [
            { label: "Logo placement on screen X & Y", value: "-" },
            { label: "Logo size on screen %", value: "-" },
            { label: "Location font, size and X&Y", value: "-" },
            {
              label: "Lower Thirds (Name, Position) Font, Size, X&Y",
              value: "-",
            },
            { label: "Subscriber to channel CTA", value: "-" },
            { label: "Whatsapp us CTA", value: "-" },
            { label: "Call us CTA", value: "-" },
            { label: "Podcast starting 30 sec timer (Lower Left)", value: "-" },
            { label: "Font for shorts / reels subtitle", value: "-" },
            { label: "Text Effects style for Shorts", value: "-" },
          ],
        },

        {
          heading: "Thumbnail Structure:",
          bgColor: "#f4fce3",
          headerColor: "#e9fac8",
          rows: [
            { label: "Face (emotion-driven or authority look)", value: "-" },
            { label: "3–5 words max text", value: "-" },
            { label: "High contrast background", value: "-" },
            { label: "One focal point only", value: "-" },
            { label: "No paragraph text", value: "-" },
            { label: "No clutter", value: "-" },
            { label: "Use brand colors only", value: "-" },
            { label: "Same font style always", value: "-" },
          ],
        },

        {
          heading: "Output:",
          bgColor: "#fdf2e9",
          headerColor: "#fae5d3",
          rows: [
            { label: "Landscape - 1080p", value: "-" },
            { label: "Vertical - 1080p", value: "-" },
            { label: "Landscape bitrate", value: "-" },
            { label: "Vertical bitrate", value: "-" },
          ],
        },

        {
          heading: "Inspiration channels:",
          bgColor: "#fdf2e9",
          headerColor: "#fae5d3",
          rows: [
            { label: "Edits", value: "-" },
            {
              label: "Informative video",
              value: "https://www.youtube.com/@aevytv",
            },
            {
              label: "Podcast",
              value:
                "-",
            },
            {
              label: "Style",
              value: "-",
            },
          ],
        },

        {
          heading: "Subtitles Style:",
          bgColor: "#eef7fb",
          headerColor: "#d6ecf5",
          rows: [
            {
              label: "Subtitles Style",
              value:
                "1) Always present (for reels) , 2) Highlight keywords, 3) Max 2 lines, 4) Center aligned or bottom safe zone",
            },
          ],
        },

        {
          heading: "Music:",
          bgColor: "#f0fff4",
          headerColor: "#dcfce7",
          rows: [
            {
              label: "Music",
              value:
                "1) Always royalty free background music, 2) No copyright music or background score, 3) Low volume, should not be more then 25% of Speach volume, 4) Match emotion (not random)",
            },
          ],
        },

        {
          heading: "Version Control:",
          bgColor: "#f0fdfa",
          headerColor: "#ccfbf1",
          rows: [
            {
              label: "Version Control",
              value:
                "No overwriting files. Always create versions: v1 → v2 → v3 Never replace existing files.",
            },
          ],
        },

        {
          heading: "Raw File Protection:",
          bgColor: "#fff4e6",
          headerColor: "#ffe8cc",
          rows: [
            {
              label: "Raw File Protection",
              value:
                "Raw files must remain untouched. Always create a copy before editing.",
            },
          ],
        },

        {
          heading: "Working Directory:",
          bgColor: "#f8f0fc",
          headerColor: "#f3d9fa",
          rows: [
            {
              label: "Working Directory",
              value:
                "Editors must work only inside the EDIT / FIRST DRAFT folder. No folder mixing.",
            },
          ],
        },

        {
          heading: "Workflow logic (strict flow):",
          bgColor: "#fffbea",
          headerColor: "#fff3c4",
          rows: [
            {
              label: "1",
              value:
                "Coordinator creates task (Podcast / Reel / Video / Graphics)",
            },
            { label: "2", value: "System generates a unique Content ID" },
            {
              label: "3",
              value:
                "Coordinator creates folder structure : ContentID → RAW → FIRST DRAFT → EXPORT → Reels / Video",
            },
            {
              label: "4",
              value:
                "Coordinator uploads raw footage to NAS using naming: ContentID_[1/2/3...]_RAW",
            },
            {
              label: "5",
              value:
                "Editor downloads raw files → edits locally → uploads first draft to FIRST DRAFT folder",
            },
            {
              label: "6",
              value: " Editor updates first draft link inside the task card",
            },
            {
              label: "7",
              value:
                "Coordinator reviews: 1) If changes required → sends back to editor, 2)  If approved → gives go-ahead for final",
            },
            {
              label: "8",
              value: "Editor completes final edit → uploads to EXPORT folder.",
            },
          ],
        },

        {
          heading: "Rule of the system:",
          bgColor: "#fff5f5",
          headerColor: "#ffe3e3",
          rows: [
            {
              label: "1",
              value:
                "If files are not named correctly, versioned properly, or placed in the right folder — **the work will be rejected.**",
            },
          ],
        },
      ],
    },

    sudhirInsights: {
      title: "Sudhir Devkar Insights",
      tables: [
        {
          heading: "Brand",
          bgColor: "#fff9db", // light yellow
          headerColor: "#f59f00", // dark yellow
          rows: [
            { label: "Name", value: "-" },
            { label: "Tagline", value: "-" },
          ],
        },

        {
          heading: "Color Schema",
          bgColor: "#fdf2e9",
          headerColor: "#fae5d3",
          rows: [
            { label: "Primary Color (Brand dominant)", value: "#ff9500" },
            { label: "Secondary Color", value: "#ffaa00" },
            { label: "Tertiary Color", value: "#ffc300" },
            { label: "Quaternary Color", value: "#ffdd00" },
            { label: "Quinary Color", value: "#ff002d" },
            { label: "Heading Font", value: "-" },
            { label: "Background Colors (Light/Dark)", value: "-" },
          ],
        },

        {
          heading: "Fonts & Text",
          bgColor: "#ebfbee",
          headerColor: "#d3f9d8",

          rows: [
            { label: "Primery Font English", value: "Kontora" },
            { label: "Secondary Font English", value: "Area" },
            { label: "Primery Font Marathi", value: "Peridot Devanagari" },
            { label: "Secondary Font Marathi", value: "Abacaxi Devanagari" },
            { label: "Heading Font Weight", value: "-" },
            { label: "Heading Font Size", value: "-" },
            { label: "Subheading Font", value: "-" },
            { label: "Subheading Font Weight", value: "-" },
            { label: "Subheading Font Size", value: "-" },
            { label: "Body Font", value: "-" },
            { label: "Body Font Weight", value: "-" },
            { label: "Body Font Size", value: "-" },
          ],
        },

        {
          heading: "Sublogos:",
          bgColor: "#edf2ff",
          headerColor: "#dbe4ff",
          rows: [
            { label: "खरं बोलायचं तर (Marathi Podcast)", value: "-" },
            { label: "खरा खेळ (Marathi Podcast)", value: "-" },
            { label: "अन्नदाता (Marathi Podcast)", value: "-" },
            { label: "सच की बात (Hindi Podcast)", value: "-" },
            { label: "असली खेल (Hindi Podcast)", value: "-" },
            { label: "कारोबारी किसान (Hindi Podcast)", value: "-" },
          ],
        },

        {
          heading: "Intro & Outro:",
          bgColor: "#e3fafc",
          headerColor: "#c5f6fa",
          rows: [
            { label: "Intro (Landscape)", value: "-" },
            { label: "Outro (Landscape)", value: "-" },
            { label: "Intro (Vertical)", value: "-" },
            { label: "Outro (Vertical)", value: "-" },
          ],
        },

        {
          heading: "In Video Effects:",
          bgColor: "#e6fcf5",
          headerColor: "#c3fae8",
          rows: [
            { label: "Logo placement on screen X & Y", value: "-" },
            { label: "Logo size on screen %", value: "-" },
            { label: "Location font, size and X&Y", value: "-" },
            {
              label: "Lower Thirds (Name, Position) Font, Size, X&Y",
              value: "-",
            },
            { label: "Subscriber to channel CTA", value: "-" },
            { label: "Whatsapp us CTA", value: "-" },
            { label: "Call us CTA", value: "-" },
            { label: "Podcast starting 30 sec timer (Lower Left)", value: "-" },
            { label: "Font for shorts / reels subtitle", value: "-" },
            { label: "Text Effects style for Shorts", value: "-" },
          ],
        },

        {
          heading: "Thumbnail Structure:",
          bgColor: "#f4fce3",
          headerColor: "#e9fac8",
          rows: [
            { label: "Face (emotion-driven or authority look)", value: "-" },
            { label: "3–5 words max text", value: "-" },
            { label: "High contrast background", value: "-" },
            { label: "One focal point only", value: "-" },
            { label: "No paragraph text", value: "-" },
            { label: "No clutter", value: "-" },
            { label: "Use brand colors only", value: "-" },
            { label: "Same font style always", value: "-" },
          ],
        },

        {
          heading: "Output:",
          bgColor: "#fdf2e9",
          headerColor: "#fae5d3",
          rows: [
            { label: "Landscape - 1080p", value: "-" },
            { label: "Vertical - 1080p", value: "-" },
            { label: "Landscape bitrate", value: "-" },
            { label: "Vertical bitrate", value: "-" },
          ],
        },

        {
          heading: "Inspiration channels:",
          bgColor: "#fdf2e9",
          headerColor: "#fae5d3",
          rows: [
            { label: "Edits", value: "-" },
            {
              label: "Informative video",
              value: "https://www.youtube.com/@aevytv",
            },
            {
              label: "Podcast",
              value:
                "-",
            },
            {
              label: "Style",
              value: "-",
            },
          ],
        },

        {
          heading: "Subtitles Style:",
          bgColor: "#eef7fb",
          headerColor: "#d6ecf5",
          rows: [
            {
              label: "Subtitles Style",
              value:
                "1) Always present (for reels) , 2) Highlight keywords, 3) Max 2 lines, 4) Center aligned or bottom safe zone",
            },
          ],
        },

        {
          heading: "Music:",
          bgColor: "#f0fff4",
          headerColor: "#dcfce7",
          rows: [
            {
              label: "Music",
              value:
                "1) Always royalty free background music, 2) No copyright music or background score, 3) Low volume, should not be more then 25% of Speach volume, 4) Match emotion (not random)",
            },
          ],
        },

        {
          heading: "Version Control:",
          bgColor: "#f0fdfa",
          headerColor: "#ccfbf1",
          rows: [
            {
              label: "Version Control",
              value:
                "No overwriting files. Always create versions: v1 → v2 → v3 Never replace existing files.",
            },
          ],
        },

        {
          heading: "Raw File Protection:",
          bgColor: "#fff4e6",
          headerColor: "#ffe8cc",
          rows: [
            {
              label: "Raw File Protection",
              value:
                "Raw files must remain untouched. Always create a copy before editing.",
            },
          ],
        },

        {
          heading: "Working Directory:",
          bgColor: "#f8f0fc",
          headerColor: "#f3d9fa",
          rows: [
            {
              label: "Working Directory",
              value:
                "Editors must work only inside the EDIT / FIRST DRAFT folder. No folder mixing.",
            },
          ],
        },

        {
          heading: "Workflow logic (strict flow):",
          bgColor: "#fffbea",
          headerColor: "#fff3c4",
          rows: [
            {
              label: "1",
              value:
                "Coordinator creates task (Podcast / Reel / Video / Graphics)",
            },
            { label: "2", value: "System generates a unique Content ID" },
            {
              label: "3",
              value:
                "Coordinator creates folder structure : ContentID → RAW → FIRST DRAFT → EXPORT → Reels / Video",
            },
            {
              label: "4",
              value:
                "Coordinator uploads raw footage to NAS using naming: ContentID_[1/2/3...]_RAW",
            },
            {
              label: "5",
              value:
                "Editor downloads raw files → edits locally → uploads first draft to FIRST DRAFT folder",
            },
            {
              label: "6",
              value: " Editor updates first draft link inside the task card",
            },
            {
              label: "7",
              value:
                "Coordinator reviews: 1) If changes required → sends back to editor, 2)  If approved → gives go-ahead for final",
            },
            {
              label: "8",
              value: "Editor completes final edit → uploads to EXPORT folder.",
            },
          ],
        },

        {
          heading: "Rule of the system:",
          bgColor: "#fff5f5",
          headerColor: "#ffe3e3",
          rows: [
            {
              label: "1",
              value:
                "If files are not named correctly, versioned properly, or placed in the right folder — **the work will be rejected.**",
            },
          ],
        },
      ],
    },



    earpure: {
      title: "Eat Pure Greens Guidelines",
      tables: [
        {
          heading: "Editor Rules",
          rows: [
            { label: "Folder Discipline", value: "Strict" },
            { label: "Version Control", value: "v1 → v2 → v3" },
            { label: "Raw File Protection", value: "No Edit" },
          ],
        },
        {
          heading: "Workflow",
          rows: [
            { label: "Step 1", value: "Create Task" },
            { label: "Step 2", value: "Generate Content ID" },
            { label: "Step 3", value: "Upload Raw Files" },
          ],
        },
      ],
    },
  };

  const currentData = contentData[activeTab];

  return (
    <>
      <div className="container-xxl mt-4">
        <div className="page-header d-print-none">
          <div className="row g-2 align-items-center">
            <div className="col">
              <h2 className="page-title mb-1">
                <FcImport></FcImport> Creative Standard
              </h2>
              <h4 className="text-muted">
                <StepRoutes />
              </h4>
            </div>
          </div>
        </div>
        <div className="row mt-2">
          {/* 🔹 LEFT SIDEBAR */}
          <div className="col-md-3  p-3 card me-4 ">
            <h2 className="mb-3 text-center mt-2">Guidelines</h2>
            <hr className="mt-2 mb-0 ms-0 me-0 p-0"></hr>

            <ul className="list-group mt-3">
              <li
                className={`list-group-item ${
                  activeTab === "kryzen" ? "active" : ""
                }`}
                onClick={() => setActiveTab("kryzen")}
                style={{ cursor: "pointer" }}
              >
                Kryzen Biotech
              </li>

              <li
                className={`list-group-item ${
                  activeTab === "hydro" ? "active" : ""
                }`}
                onClick={() => setActiveTab("hydro")}
                style={{ cursor: "pointer" }}
              >
                Hydroponic Masterclass
              </li>

              <li
                className={`list-group-item ${
                  activeTab === "sudhirMarathi" ? "active" : ""
                }`}
                onClick={() => setActiveTab("sudhirMarathi")}
                style={{ cursor: "pointer" }}
              >
                Sudhir Devkar Marathi
              </li>


              <li
                className={`list-group-item ${
                  activeTab === "sudhirHindi" ? "active" : ""
                }`}
                onClick={() => setActiveTab("sudhirHindi")}
                style={{ cursor: "pointer" }}
              >
                Sudhir Devkar Hindi
              </li>


              <li
                className={`list-group-item ${
                  activeTab === "sudhirMarathiClips" ? "active" : ""
                }`}
                onClick={() => setActiveTab("sudhirMarathiClips")}
                style={{ cursor: "pointer" }}
              >
                Sudhir Devkar Marathi Clips
              </li>


              <li
                className={`list-group-item ${
                  activeTab === "sudhirHindiClips" ? "active" : ""
                }`}
                onClick={() => setActiveTab("sudhirHindiClips")}
                style={{ cursor: "pointer" }}
              >
                Sudhir Devkar Hindi Clips
              </li>
              
              <li
                className={`list-group-item ${
                  activeTab === "sudhirMarathiShorts" ? "active" : ""
                }`}
                onClick={() => setActiveTab("sudhirMarathiShorts")}
                style={{ cursor: "pointer" }}
              >
                Sudhir Devkar Marathi Shorts
              </li>

              <li
                className={`list-group-item ${
                  activeTab === "sudhirHindiShorts" ? "active" : ""
                }`}
                onClick={() => setActiveTab("sudhirHindiShorts")}
                style={{ cursor: "pointer" }}
              >
                Sudhir Devkar Hindi Shorts
              </li>

              <li
                className={`list-group-item ${
                  activeTab === "sudhirInsights" ? "active" : ""
                }`}
                onClick={() => setActiveTab("sudhirInsights")}
                style={{ cursor: "pointer" }}
              >
                Sudhir Devkar Insights
              </li>

              <li
                className={`list-group-item ${
                  activeTab === "earpure" ? "active" : ""
                }`}
                onClick={() => setActiveTab("earpure")}
                style={{ cursor: "pointer" }}
              >
                Eat Pure Greens
              </li>
            </ul>
          </div>

          {/* 🔹 RIGHT CONTENT */}
          {/* <div className="col-md-8 p-4 card" style={{
            maxHeight:"80vh",
            overflow:"scroll"
        }}>
          <h2 className="mb-4 text-center">{currentData.title}</h2>
          <hr className="m-0 p-0"></hr>


          {currentData.tables.map((table, index) => (
            <div key={index} className="mb-4 mt-2">
              <h3 className="mb-2">{table.heading}</h3>

              <table className="table table-bordered">
                <thead className="table-dark">
                  <tr>
                    <th>Field</th>
                    <th>Value</th>
                  </tr>
                </thead>

                <tbody>
                  {table.rows.map((row, i) => (
                    <tr key={i}>
                      <td>{row.label}</td>
                      <td>{row.value}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ))}
        </div> */}

          <div
            className="col-md-8 p-4 card"
            style={{
              maxHeight: "80vh",
              overflow: "scroll",
            }}
          >
            <h2 className="mb-4 text-center">{currentData.title}</h2>
            <hr className="m-0 p-0" />

            {currentData.tables.map((table, index) => (
              <div key={index} className="mb-4 mt-3">
                <h3 className="mb-2" style={{ color: "black" }}>
                  {table.heading}
                </h3>

                <table
                  className="table table-bordered"
                  style={{
                    backgroundColor: table.bgColor,
                  }}
                >
                  <thead>
                    <tr
                    //   style={{
                    //     backgroundColor: table.headerColor,
                    //     color: "#fff",
                    //   }}
                    >
                      <th
                        style={{
                          width: "40%",
                          backgroundColor: "#e7f5ff", // light blue
                        }}
                      >
                        Field
                      </th>
                      <th
                        style={{
                          width: "40%",
                          backgroundColor: "#e7f5ff", // light blue
                        }}
                      >
                        Value
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {table.rows.map((row, i) => (
                      <tr key={i}>
                        <td>{row.label}</td>
                        <td>{row.value}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ))}
          </div>
        </div>
      </div>
      <Footer></Footer>
    </>
  );
};

export default CreativeStandard;
